export const SET_ALL_ASSIGNATIONS = 'SET_ALL_ASSIGNATIONS'
export const ADD_NEW_ASSIGNATION = 'ADD_NEW_ASSIGNATION'
export const DELETE_ASSIGNATION = 'DELETE_ASSIGNATION'
export const UPDATE_EXISTING_ASSIGNATION = 'UPDATE_EXISTING_ASSIGNATION'
